import { IconRalphWiggum } from "@/assets/icons/IconRalphWiggum";
import type { AgentMessageFragmentAgentModeChange } from "@/hooks/use-stream-conversation";
import { type FC } from "react";

export const FragmentAgentModeChange: FC<{
    fragment: AgentMessageFragmentAgentModeChange;
}> = ({ fragment }) => {
    return (
        <div className="mt-2 flex items-center gap-2 text-sm text-content-secondary">
            <IconRalphWiggum size={20} />
            <span>{fragment.message}</span>
        </div>
    );
};
